import {Component} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {DeviceRelocationService} from "./device-relocation.service";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {CreateRelocationDialogComponent} from "./create-relocation-dialog.component";
import {handleErrors} from "../misc/handle-errors.decorator";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./device-relocation-list.template.pug",
  providers: [
    DeviceRelocationService,
    DialogService,
  ],
})
export class DeviceRelocationListComponent extends RouteHelper {
  relocations: any[] = [];
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";
  searchHelp: any[] = [
    {property: "Workflow Name", examples: ["Workflow Y", "\"Y\"", "name:Workflow Y"]},
    {property: "Site Name", examples: ["Site X", "\"X\"", "siteName:Site X"]},
    {property: "Project Name", examples: ["Project Z", "\"Z\"", "projectName:Project Z"]},
  ];

  siteId: string;
  projectId: string;
  error: Error;

  paramsMap: RouteMapping[] = [
    {fieldName: "currentPage", paramName: "page", defaultValue: DEFAULT_PAGE, type: "number"} as RouteMapping,
    {fieldName: "pageSize", paramName: "limit", defaultValue: DEFAULT_PAGE_LIMIT, type: "number"} as RouteMapping,
    {fieldName: "searchText", paramName: "search"} as RouteMapping,
    {fieldName: "siteId", paramName: "siteId"} as RouteMapping,
    {fieldName: "projectId", paramName: "projectId"} as RouteMapping,
  ];

  constructor(
    private deviceRelocationService: DeviceRelocationService,
    public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
  ) {
    super();
  }

  navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["device-relocations"], {queryParams, skipLocationChange});
  }

  @handleErrors()
  async loadData(): Promise<void> {
    const {rows, count} = await this.deviceRelocationService.getRelocationDefects(
      +(this.currentPage) - 1,
      +(this.pageSize),
      this.searchText,
      this.siteId,
      this.projectId,
    );
    this.relocations = rows;
    this.maxPages = Math.ceil(count / (+this.pageSize));
    this.totalCount = count;
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }

    this.syncRoute();
  }

  @handleErrors()
  async create(): Promise<void> {
    const result = await CreateRelocationDialogComponent.showCreateDialog(this.dialogService, {
      projectId: this.projectId,
      siteId: this.siteId,
    });

    if (result) {
      await this.loadData();
    }
  }
}
